import type { JSX } from 'react';
import { cn } from '@/lib/utils';

/**
 * F5-T2 · El pager «Anterior / Siguiente» como patrón heredable.
 *
 * Nació en SCALE (074) para el listado admin, se copió al navigator en
 * NAV-PAGINACION (25 en 25) y T2 lo consagra como EL componente único: área
 * táctil ≥44px, número de página real en el medio, y solo se monta cuando hay
 * más de una página — el total real lo dice el kicker de cada pantalla, no
 * el pager. Los textos vienen del caller (cada módulo con su i18n).
 */
export function Pager({ page, pages, onPage, prevLabel, nextLabel, pageLabel, className, busy }: {
  page: number;              // 0-based
  pages: number;
  onPage: (n: number) => void;
  prevLabel: string;
  nextLabel: string;
  /** Texto ya resuelto, p.ej. «Página 2 de 5». */
  pageLabel: string;
  className?: string;
  /** Paginación server-side: deshabilita ambos mientras trae la página. */
  busy?: boolean;
}): JSX.Element | null {
  if (pages <= 1) return null;
  const btn = 'min-h-[44px] px-4 rounded-lg border border-nav-line bg-white font-body font-semibold text-[13px] text-nav-navy disabled:opacity-40 disabled:cursor-not-allowed hover:bg-nav-softer';
  return (
    <div className={cn('flex items-center justify-between gap-3 mt-3', className)} data-chassis="pager">
      <button type="button" className={btn} disabled={busy || page <= 0} onClick={() => onPage(page - 1)}>
        {prevLabel}
      </button>
      <span className="text-[13px] text-nav-slate">{pageLabel}</span>
      <button type="button" className={btn} disabled={busy || page >= pages - 1} onClick={() => onPage(page + 1)}>
        {nextLabel}
      </button>
    </div>
  );
}
